import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { colors } from 'Constants';
import { Footnote } from 'Components/core';
import { times } from 'Root/libs/utils';

function hexToRgb(hex, alpha) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `rgba(
      ${parseInt(result[1], 16)},
      ${parseInt(result[2], 16)},
      ${parseInt(result[3], 16)},
      ${alpha || 1})`
    : undefined;
}

const Table = styled.table`
  border-collapse: collapse;
  tr > * {
    padding: 8px;
    ${props => props.center && css(`text-align: center;`)}
  }

  th {
    font-weight: normal;
    text-align: left;
  }
`;

const TH = styled.th`
  font-family: 'Elevance Sans Semibold';
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: #333;
`;

const SubHeader = styled.td`
  height: 45px;
  font-family: 'Elevance Sans Regular';
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  color: #131331;
`;

const InnerContentDiv = styled.div`
  font-family: 'Elevance Sans Regular';
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  text-align: left;
  color: #131331;
  padding-left: 10px;
  > b {
    font-family: 'Elevance Sans Semibold';
    font-size: 18px;
    line-height: 26px;
    text-align: left;
    color: #131331;
  }
`;

export default props => {
  // TODO: Switch to Case when RRD sends consistently cased data
  const decodeHeader = header => {
    const map = {
      deductible: 'Deductible',
      officevisit: 'Office Visit',
      'out-of-pocket': 'Out-of-Pocket',
      pharmacyChartSection: 'Pharmacy'
    };
    return map[header];
  };

  const { headers, sets, gotDocType } = props;

  const headerColors = ['#ffffff', ...times('#EEEEEE', 6)];
  const subHeaderColors = ['#ffffff', ...times('#F5F5F5', 6)];
  const contentColor = times('#EEEEEE', 13);
  const contentColor2 = times('#F5F5F5', 13);

  const borderRight = { borderRight: '14px solid #ffffff' };

  return (
    <div
      style={{ overflowX: 'auto', display: 'flex', justifyContent: 'center' }}
    >
      <Table
        border
        color1="#666666"
        color2={colors.accent}
        color3="#649b41"
        color4="#f15e3f"
      >
        <tbody>
          {headers && [
            <tr key="headers">
              {headers.map(({ type, name }, i) => (
                <TH
                  style={{
                    textAlign: 'center',
                    backgroundColor: headerColors[i],
                    color: '#333',
                    ...borderRight
                  }}
                  colSpan={i === 0 ? 0 : gotDocType ? 2 : 0}
                  key={i}
                >
                  {name}
                  <br />
                  <Footnote>{type}</Footnote>
                </TH>
              ))}
            </tr>,
            gotDocType ? (
              <tr>
                <td
                  style={{
                    backgroundColor: subHeaderColors[0],
                    ...borderRight
                  }}
                ></td>
                {headers.slice(1).map((a, index) => {
                  return (
                    <>
                      {' '}
                      <SubHeader
                        style={{
                          backgroundColor: subHeaderColors[index + 1]
                        }}
                      >
                        Doctors in the plan
                      </SubHeader>
                      <SubHeader
                        style={{
                          backgroundColor: subHeaderColors[index + 1],

                          ...borderRight
                        }}
                      >
                        Doctors out of the plan
                      </SubHeader>
                    </>
                  );
                })}
              </tr>
            ) : (
              <></>
            ),
            ...sets.map((set, setC) => [
              <tr style={{ height: 0 }} key={set.header}>
                <td style={{ height: 0, padding: 0, paddingBottom: 8 }}></td>
              </tr>,
              ...set.rows.map((row, j) => (
                <tr className={j % 2 === 0 ? 'alt-color' : ''} key={j}>
                  {row.map((content, k) => {
                    if (k == 0 && j == 0) {
                      content = `<b>${
                        decodeHeader(set.header)
                          ? decodeHeader(set.header) + '<br/>'
                          : ''
                      }</b>${content}`;
                    }
                    if (k % 2 != 0) {
                      borderRight.borderRight = 'none';
                    } else {
                      borderRight.borderRight = '14px solid #ffffff';
                    }

                    return (
                      <>
                        <td
                          key={k}
                          style={{
                            backgroundColor:
                              setC % 2 == 0
                                ? contentColor[k]
                                : contentColor2[k],
                            textAlign: k == 0 ? 'left' : 'center',
                            ...borderRight
                          }}
                        >
                          <InnerContentDiv
                            style={{
                              textAlign: ('' + content).includes('<li>')
                                ? 'left'
                                : 'center'
                            }}
                            dangerouslySetInnerHTML={{ __html: content }}
                          ></InnerContentDiv>
                        </td>
                      </>
                    );
                  })}
                </tr>
              ))
            ])
          ]}
        </tbody>
      </Table>
    </div>
  );
};
